import { Button, Modal } from "semantic-ui-react";

interface IProps {
    unpublishModalOpen: boolean;
    setUnpublishModalOpen: (open: boolean) => void;
    handleReportUnpublish: () => void;
}
export const UnpublishReportModal = ({
    unpublishModalOpen,
    setUnpublishModalOpen,
    handleReportUnpublish,
}: IProps) => {
    return (
        <Modal open={unpublishModalOpen} onClose={() => setUnpublishModalOpen(false)}>
            <Modal.Header>Are you sure you want to unpublish the report?</Modal.Header>
            <Modal.Content>
                <p>
                    Unpublishing the report will remove it from the public view if the report was
                    publicly available and allow you to additionally edit it's content.
                </p>
                <p>You will need to publish it again once the editing is finished.</p>
            </Modal.Content>
            <Modal.Actions>
                <Button content="Cancel" onClick={() => setUnpublishModalOpen(false)} />
                <Button content="Unpublish" primary onClick={handleReportUnpublish} />
            </Modal.Actions>
        </Modal>
    );
};
